/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedProjectDTO } from './ReferencedProjectDTO';
import {
    ReferencedProjectDTOFromJSON,
    ReferencedProjectDTOFromJSONTyped,
    ReferencedProjectDTOToJSON,
    ReferencedProjectDTOToJSONTyped,
} from './ReferencedProjectDTO';

/**
 * 
 * @export
 * @interface WorkProjectDTO
 */
export interface WorkProjectDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkProjectDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkProjectDTO
     */
    role?: string;
    /**
     * 
     * @type {ReferencedProjectDTO}
     * @memberof WorkProjectDTO
     */
    project?: ReferencedProjectDTO;
}

/**
 * Check if a given object implements the WorkProjectDTO interface.
 */
export function instanceOfWorkProjectDTO(value: object): value is WorkProjectDTO {
    return true;
}

export function WorkProjectDTOFromJSON(json: any): WorkProjectDTO {
    return WorkProjectDTOFromJSONTyped(json, false);
}

export function WorkProjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkProjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'role': json['role'] == null ? undefined : json['role'],
                  'project': json['project'] == null ? undefined : ReferencedProjectDTOFromJSON(json['project']),
    };
}

export function WorkProjectDTOToJSON(json: any): WorkProjectDTO {
    return WorkProjectDTOToJSONTyped(json, false);
}

export function WorkProjectDTOToJSONTyped(value?: WorkProjectDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'role': value['role'],
        'project': ReferencedProjectDTOToJSON(value['project']),
    };
}


